import { render, staticRenderFns } from "./content-chat-layout.vue?vue&type=template&id=5c8a718d"
import script from "./content-chat-layout.vue?vue&type=script&lang=js"
export * from "./content-chat-layout.vue?vue&type=script&lang=js"
import style0 from "./content-chat-layout.vue?vue&type=style&index=0&id=5c8a718d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports